// extracted by mini-css-extract-plugin
export default {"productDetailHeader":"CategoryListCard_productDetailHeader__j8Sp5","icons":"CategoryListCard_icons__QXtPZ"};